import styled from 'styled-components';
import {
  ecoleFrancaiseGreen,
  fontFamilyRoboto,
} from '@components/hoc/Theme/Theme.styled';

export const GridContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

export const GridItem = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    props.$active ? '1px solid #00D2A4' : '1px solid #e5e5e5'};
  ;
  box-shadow: 0 3px 6px #00000008;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 14px !important;
  font-family: ${fontFamilyRoboto};

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    padding: 4px;
  }

  &:hover {
    transition: 0.1s;
    border-color: transparent;
    box-shadow: 0 0 0 2px ${ecoleFrancaiseGreen};
  }

  div {
    width: 25%;
  }

  p {
    width: 80%;
    padding-left: 5px;
    font-family: ${fontFamilyRoboto};
    font-size: 16px !important;
    font-weight: 400 !important;
    letter-spacing: normal !important;
  }

  background-color: ${(props) => (props.$active ? '#E2F8F5' : 'white')};

  padding: 1rem;
  height: 4rem;
`;

export const GridInput = styled.input.attrs({type: 'radio'})`
  display: none !important;
`;

export const GridIcon = styled.div`
  text-align: center;
  line-height: 0;
`;
